import type { Theme } from "./types";

export const theme: Theme = {
    page_background: {
        normal: "var(--rs-color-background-page)",
        highlighted: "var(--rs-color-background-page-faded)",
    },
    divider: "var(--rs-color-background-neutral-faded)",
};
